import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "warehouse";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取仓库列表
    async getWarehouseList({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingDepot/GetPage?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //新增仓库
    async addWarehouse({ commit }, payload) {
      let result = await api.post("/api/WeighingDepot", payload);
      return result;
    },
    //获取单个仓库信息
    async getSingleView({ commit }, payload) {
      let result = await api.get(`/api/WeighingDepot/${payload}`);
      return result.data;
    },
    // 修改仓库
    async editWarehouse({ commit }, payload) {
      let result = await api.put(`/api/WeighingDepot`, payload);
      return result;
    },
    // 删除仓库
    async deleteWarehouse({ commit }, payload) {
      let result = await api.delete(`/api/WeighingDepot/${payload}`);
      return result;
    },
  },
});

export default moduleName;
